import { render } from "./KnowledgeCardInterview.vue?vue&type=template&id=54858a46&scoped=true"
import script from "./KnowledgeCardInterview.vue?vue&type=script&lang=js"
export * from "./KnowledgeCardInterview.vue?vue&type=script&lang=js"

import "./KnowledgeCardInterview.vue?vue&type=style&index=0&id=54858a46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54858a46"]])

export default __exports__